import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { IntegrationAllowance } from '@/types/integration';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'query'> & {
  all?: boolean;
};

export async function getIntegrationAllowances(
  scope: RequestScope,
  params: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<IntegrationAllowance[]>> {
  try {
    if (scope.kind !== 'organization') {
      throw new Error('Integration allowance reads require an organization target scope');
    }
    const response = await scopedApi(scope).get<EndpointResponse<IntegrationAllowance[]>>('/integration_allowance', {
      ...options,
      params: { all: params.all, query: params.query },
    });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
